import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { DateTime } from 'luxon';
import { MailEventLog, MailEventLogType } from '../../eventlogs/MailEventlog.js';
import { workshopStornoEmail } from '../../mailer/mailTemplates.js';
import { chancenWerkMailer } from '../../mailer/server/mailer.js';
import { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';
import { WorkshopAppointment } from '../entities/WorkshopAppointment.js';

export const sendWorkshopStornoMail = registerQuery({
  type: () => Boolean,
  operationName: 'sendWorkshopStornoMail',
  resolve: (appointmentID: string, userID: string) => {
    return async () => {
      const appointment = await WorkshopAppointment.getByID<WorkshopAppointment>(appointmentID)({
        ...WorkshopAppointment.allFields,
        workshop: {
          title: 1,
          appointmentInfo: 1,
        },
      });

      const userCol = await getRawCollection<ChancenwerkUser>(ChancenwerkUser._collectionName);
      const user = await userCol.findOne({
        _id: userID,
      });

      if (!appointment || !user) {
        throw new Error('Appointment or user not found');
      }

      try {
        const msg = await Message.compose({
          subject: 'CHANCENakademie: Workshop Stornierung',
          html: workshopStornoEmail({
            name: `${user.vorname} ${user.nachname}`,
            workshopName: appointment.workshop?.title ?? '',
            date: appointment.start ?? DateTime.now(),
            end: appointment.end ?? DateTime.now(),
          }),
        });
        await chancenWerkMailer.sendMail(msg, new Recipient(user.email));
        await new MailEventLog({
          userID: user._id,
          mailType: MailEventLogType.WORKSHOP_STORNO,
          successful: true,
          sendMailError: undefined,
          emailAddress: user.email,
        }).create();
      } catch (e: any) {
        await new MailEventLog({
          userID: user._id,
          mailType: MailEventLogType.WORKSHOP_STORNO,
          successful: false,
          sendMailError: e.message,
          emailAddress: user.email,
        }).create();
      }
    };
  },
  options: {},
  params: [
    { type: () => String, name: 'appointmentID' },
    { type: () => String, name: 'userID' },
  ],
});
